<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">用户分红</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分红列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions"></div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'foundationProject',
  data() {
    return {};
  },
  components: {
    List
  },
  computed: {
    ...mapState('userdividend', ['pagination'])
  },
  methods: {
    ...mapActions('userdividend', ['getList', 'getCoinTypeList']),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
